/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router';

import ReactSuperSelect from 'react-super-select';
import moment from 'moment';
import uuid from 'node-uuid';

import {Col,Form,FormGroup,FormControl,ControlLabel,Button, Nav, NavItem, Panel,Glyphicon} from 'react-bootstrap';
import userAPI from '../../../api/awsUserAPI';
import Authentication from '../../../authentication/awsAuthentication';
import ActionResult from '../../../stores/ActionResult';
import APIActions from '../../../actions/apiActions';
import UIHelpers from '../../../library/UIHelpers';

import UserStore from '../../../stores/UserStore';
import DealerStore from '../../../stores/DealerStore';
import UserAPI from "../../../api/awsUserAPI";


class AddUserView extends React.Component {
    constructor(props) {
        console.log("[AddUserView] - initialisation");

        super(props);

        this.state = {
            activeTab : 1,
            userId   : null,
            email : "",
            fullname : "",
            role : "",
            phonenumber : "",
            password : "",
            selectedDealer : null,
            dealers : [],
            dealerView : [],
            dirty  : false
        }

        this.onChangeData = this.onChangeData.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.cancelUser = this.cancelUser.bind(this);
        this.selectHandler = this.selectHandler.bind(this);
        this.loadDealers = this.loadDealers.bind(this);
        this._onDealerChange = this._onDealerChange.bind(this) ;

        this.onActionComplete = this.onActionComplete.bind(this);
        this.userSaveHandler = this.userSaveHandler.bind(this);
    }

    componentDidMount() {
        console.log("[AddUserView] - componentDidMount");
        DealerStore.addChangeListener(this._onDealerChange) ;
        this.loadDealers();
    }

    componentWillUnmount() {
        console.log("[AddUserView] - componentWillUnmount");
        DealerStore.removeChangeListener(this._onDealerChange) ;
    }

    _onDealerChange() {
        var s = this.state ;
        s.dealers = DealerStore.dealers() ;
        s.dealerView = s.dealers.map(item => ({id: item.dealerId, name: item.name, size: "Small", dealer: item}));
        s.loading = false ;
        this.setState(s);
    }

    shouldComponentUpdate(np,ns) {
        return true ;
    }

    componentWillReceiveProps(np) {
        var s = this.state ;
        if (!np.user) {
            s.activeTab = 2 ;
            s.userId = null ;
            s.email = "" ;
            s.fullname = "" ;
            s.phonenumber = "" ;
            s.role = "" ;
        }
        else {
            switch (np.user.role) {
                case "TECHSUPPORT" : s.activeTab = 1 ; break ;
                case "DEALER" : s.activeTab = 2 ; break ;
                case "ADMIN" : s.activeTab = 3 ; break ;
                case "EXTERNALUSER" : s.activeTab = 4 ; break ;
                default: s.activeTab = 2 ;
            }
            s.userId = np.user.userId ;
            s.email = np.user.email ;
            s.fullname = np.user.name ;
            s.phonenumber = np.user.phone ;
            s.role = np.user.role ;
        }

        s.dirty = false ;
        this.setState(s);
    }

    loadDealers() {
        var s = this.state ;
        s.loading = true ;
        this.setState(s);
        APIActions.allDealers() ;
    }

    selectHandler(dealer) {
        console.log("[DEALER SELECT] - " ,dealer);
        var s = this.state ;
        s.selectedDealer = dealer.dealer ;
        this.setState(s);
    }

    onChangeData(e) {
        e.preventDefault() ;
        var s = this.state ;

        var un = ReactDOM.findDOMNode(this.refs.email).value;
        var fn = ReactDOM.findDOMNode(this.refs.fullname).value;
        var ph = ReactDOM.findDOMNode(this.refs.phonenumber).value;
        if (!this.props.user) {
            var pw = ReactDOM.findDOMNode(this.refs.password).value;
            s.password = pw ;
        }
        s.email = un.toLowerCase() ;
        s.phonenumber = ph ;
        s.fullname = fn ;
        s.dirty = true ;
        this.setState(s);
    }

    onActionComplete(ss) {
        if (ss === undefined || ss === null) {
            return ; // shouldn't happen but just in case'
        }

        switch (ss.action) {
            // case "ALL_USERS": this.userLoadHandler(ss.result); break ;
            case "SAVE_USER" : this.userSaveHandler(ss.result) ; break ;
            default:  break; // Unexpected result - not expected
        }
    }

    userSaveHandler(cs) {
        switch (cs.status) {
            case "OK":
                console.log("USER SAVED - RELOADING:" + cs.result.state);
                UIHelpers.showMessage("User Details Saved successfully");
                // this.loadUsers() ;
                this.props.closeHandler({cancelled: true});
                break;
            case "FAIL":
                console.log("ERROR SAVING USER");
                UIHelpers.showMessage("A problem occurred saving those User changes")
                // this.loadUsers() ;
                break;
            default:
                break;
        }
    }


    async saveUser() {
        console.log("SAVE USER with dealer: ", this.state.selectedDealer);
        var role = "DEALER" ;
        var dealer = null ;
        console.log("ACTIVE TAB: ", this.state.activeTab);
        switch (this.state.activeTab) {
            case 1 : role = "TECHSUPPORT" ; break ;
            case 2 :
                role = "DEALER" ;
                if (this.state.selectedDealer) {
                    dealer = this.state.selectedDealer.dealerId;
                }
                break ;
            case 3 : role = "ADMIN" ; break ;
            case 4 : role = "EXTERNALUSER" ; break ;
            default: break ;
        }

        var la = moment().format('YYYYMMDDHHmmss');
        var user = {
            "userId": this.state.userId,
            "created": this.props.user ? this.props.user.created : la,
            "lastAccess": la,
            "name":  this.state.fullname,
            "role": role,
            "status": "ACTIVE",
            "email": this.state.email.toLowerCase()
        } ;

        if (dealer) {
            user.dealerId = dealer ;
        }

        if (this.state.phonenumber) {
            user.phone = this.state.phonenumber ;
        }

        try {
            if (user.userId) {
                let updateResult = await UserAPI.updateUser(user) ;
            }
            else {
                user.password = this.state.password;
                let createResult = await UserAPI.createUser(user) ;
            }
            UIHelpers.showMessage("User Details Saved successfully");
            this.props.closeHandler({cancelled: true});
        }
        catch(e) {
            UIHelpers.showMessage("A problem occurred saving creating user - please retry");
        }
    }


    saveUserOld() {
        console.log("SAVE USER with dealer: ", this.state.selectedDealer);
        var role = "DEALER" ;
        var dealer = null ;
        console.log("ACTIVE TAB: ", this.state.activeTab);
        switch (this.state.activeTab) {
            case 1 : role = "TECHSUPPORT" ; break ;
            case 2 :
                role = "DEALER" ;
                if (this.state.selectedDealer) {
                    dealer = this.state.selectedDealer.dealerId;
                }
                break ;
            case 3 : role = "ADMIN" ; break ;
            case 4 : role = "EXTERNALUSER" ; break ;
            default: break ;
        }

        var la = moment().format('YYYYMMDDHHmmss');
        var user = {
            "userId": this.state.userId,
            "created": this.props.user ? this.props.user.created : la,
            "dealerId": dealer,
            "lastAccess": la,
            "name":  this.state.fullname,
            "role": role,
            "status": "ACTIVE",
            "email": this.state.email.toLowerCase(),
            "phone" : this.state.phonenumber
        } ;


        if (!dealer) {
            user.dealerId = undefined ;
        }

        if (!user.userId) {
            // MUST BE ADDING USER
            console.log("ADDING USER:");
            user.userId = uuid.v4() ;

            var onsuccess = (v) => {
                console.log("USER CREATE ON COGNITO WAS SUCCESSFUL");
                userAPI.saveUser(user, ActionResult.make("SAVE_USER",this.onActionComplete));
            }

            var onfailure = (e) => {
                console.log("USER CREATE FAILED : ", e);
                UIHelpers.showMessage("A problem occurred saving creating user: " + e);
            }

            Authentication.createUser(user.email, user.name, this.state.password, user.role, onsuccess, onfailure) ;
        }
        else {
            userAPI.saveUser(user, ActionResult.make("SAVE_USER",this.onActionComplete));
        }
    }

    cancelUser() {
        console.log("CANCEL USER");
        this.props.closeHandler({cancelled: true});
    }

    handleTypeSelect(eventKey) {
        var s = this.state ;
        s.activeTab = eventKey ;
        this.setState(s);
    }

    render() {
        var isAdmin = UserStore.isAdministrator();
        var header = (<div>
                <b>Manage User</b>
                <div className="pull-right">
                    <Button type="button" bsSize="small" bsStyle="danger" onClick={this.cancelUser}><Glyphicon glyph="remove"/>{' '}Cancel</Button>{' '}
                    <Button type="button" bsSize="small" bsStyle="success" disabled={!this.state.dirty} onClick={this.saveUser}><Glyphicon glyph="save"/>{' '}Save</Button>
                </div>
            </div>);

        let hs = this.state.dirty ? "danger" : "success";

        return (
            <Panel header={header}  bsStyle={hs}>
                <Form horizontal onSubmit={event => event.preventDefault()}>

                    <FormGroup controlId="fmuserType">
                        <Col componentClass={ControlLabel} sm={2}>User Type</Col>
                        <Col>
                            <Nav  bsStyle="pills"  activeKey={this.state.activeTab} onSelect={this.handleTypeSelect.bind(this)}>
                                <NavItem eventKey={1} active={this.state.activeTab===1} >Tech Support</NavItem>
                                <NavItem eventKey={2} active={this.state.activeTab===2} >Dealer</NavItem>
                                {isAdmin && <NavItem eventKey={3} active={this.state.activeTab===3} >Admin</NavItem>}
                                <NavItem eventKey={4} active={this.state.activeTab===4} >External</NavItem>
                            </Nav>
                        </Col>
                    </FormGroup>

                     <FormGroup controlId="formHorizontalEmail" hidden={this.state.activeTab !== 2}>
                        <Col componentClass={ControlLabel} sm={2}>Dealer</Col>
                        <Col sm={5}>
                            <ReactSuperSelect placeholder="Select Dealer"
                                                clearSearchOnSelection={false}
                                                dataSource={this.state.dealerView}
                                                onChange={this.selectHandler}
                                                searchable={true} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>Email</Col>
                        <Col sm={5}>
                            <FormControl onChange={this.onChangeData} type="text" placeholder="email" ref="email" value={this.state.email} readOnly={this.state.userId !== null}/>
                        </Col>
                    </FormGroup>

                    {(this.state.userId !== null) &&
                        <FormGroup controlId="formHorizontalEmail">
                            <Col componentClass={ControlLabel} sm={3}></Col>
                            <span>Email address cannot be modified after creation</span>
                        </FormGroup>
                    }

                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>Full Name</Col>
                        <Col sm={5}>
                            <FormControl onChange={this.onChangeData} type="text" placeholder="fullname" ref="fullname" value={this.state.fullname}/>
                        </Col>
                    </FormGroup>

                    {!this.props.user &&
                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>Password</Col>
                        <Col sm={5}>
                            <FormControl onChange={this.onChangeData} type="text" placeholder="password" ref="password" value={this.state.password}/>
                        </Col>
                    </FormGroup>
                    }

                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>Phone Number</Col>
                        <Col sm={5}>
                            <FormControl onChange={this.onChangeData} type="text" placeholder="phone number" ref="phonenumber" value={this.state.phonenumber}/>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel>
        );
    }
}

export default withRouter(AddUserView);



// WEBPACK FOOTER //
// ./src/app/components/admin/user/addUserView.react.js